import "./Contact.css"
import React, { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";

import contactDataTr from '../data/jsons/contact.tr.json'
import contactDataEn from '../data/jsons/contact.en.json'

import IdContactPropt from './IdContactPropt'
import MailIcon from '../data/icons/Mail.svg'
import GithubIcon from '../data/icons/Github.svg'
import LinkedinIcon from '../data/icons/Linkedin.svg'
import ImstagramIcon from '../data/icons/Instagram.svg'

const iconMap = {
    "Mail": MailIcon,
    "Linkedin": LinkedinIcon,
    "Github": GithubIcon,
    "Instagram": ImstagramIcon
};

function AlwaysOpenPopup({ position, children }) {
  const map = useMap();
  const popupRef = useRef();

  useEffect(() => {
    if (popupRef.current) {
      popupRef.current.openOn(map); // popup'ı harita açılır açılmaz göster
    }
  }, [map]);

  return (
    <Popup
      ref={popupRef}
      position={position}
      autoClose={false}
      closeOnClick={false}
    >
      {children}
    </Popup>
  );
}

export default function Contact() {
  const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    useEffect(() => {
        const handleLangChange = () => {
            setIsEnglish(localStorage.getItem('pageLanguage') === 'true');
        };
        window.addEventListener("languageChange", handleLangChange);
        return () => {
            window.removeEventListener("languageChange", handleLangChange);
        };
    }, []);

    const contactData = isEnglish ? contactDataEn : contactDataTr;

  return (
    <div id='Contact-Container' className='Containers'>
            <p className='Page-Header'>{contactData.header.title}</p>
            <hr className='Header-Line'/>
            <p className="Page-Text">{contactData.header.paragraphs}</p>
            <p className="Sub-Header">{isEnglish ? "Social Media Accounts" : "Sosyal Medya Hesaplarım"}</p>
            <div className="Contact-Items">
                {contactData.contact.map((item) => (
                    <IdContactPropt Header={item.title} Text={item.data} IsLink={true} Link={item.url} Photo={iconMap[item.icon]}/>
                ))}
            </div>
            <p className="Sub-Header Location">{isEnglish ? "Location" : "Konum"}</p>
            <div className="Contact-Map" style={{ height: "30vh", width: "100%" }}>
        <MapContainer
            center={[contactData.coordinates[0], contactData.coordinates[1]]}
            zoom={8}
            style={{ height: "100%", width: "100%"}}
        >
            {/* Dark mode tile */}
            <TileLayer
            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
            subdomains="abcd"
            maxZoom={20}
            />

            <CircleMarker
            center={[contactData.coordinates[0], contactData.coordinates[1]]}
            radius={15}
            color="#E6695E"
            fillColor="#E6695E"
            fillOpacity={0.8}
            />

            <AlwaysOpenPopup position={[contactData.coordinates[0], contactData.coordinates[1]]} className="Popup-Btn">
            📍 {isEnglish ? "My Location" : "Konumum"}
            </AlwaysOpenPopup>
        </MapContainer>
        </div>
    </div>
    
  );
}
